import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ApprovalSettings, { ApprovalApprovers, ApprovalExemptions } from './ApprovalSettings';
import ApprovalQueue from './ApprovalQueue';
import MyApprovals from './MyApprovals';
import ApprovalAccess from './components/ApprovalAccess';
import { APPROVAL_ROUTES, APPROVAL_REDIRECTS } from './navigation';

const pages = [
  { path: APPROVAL_ROUTES.settings, Page: ApprovalSettings, admin: true },
  { path: APPROVAL_ROUTES.approvers, Page: ApprovalApprovers, admin: true },
  { path: APPROVAL_ROUTES.exemptions, Page: ApprovalExemptions, admin: true },
  { path: APPROVAL_ROUTES.queue, Page: ApprovalQueue, admin: false },
  { path: APPROVAL_ROUTES.mine, Page: MyApprovals, admin: false },
];

export default function ApprovalRoutes() {
  const scope = useSelector(
    (state: any) => `${state.auth.current_company}:${state.auth.current_employee}`
  );
  return (
    <>
      {Object.entries(APPROVAL_REDIRECTS).map(([from, to]) => (
        <Route
          key={from}
          exact
          path={from}
          render={({ location }) => (
            <Redirect to={{ pathname: to, search: location.search, hash: location.hash }} />
          )}
        />
      ))}
      {pages.map(({ path, Page, admin }) => (
        <Route
          key={path}
          exact
          path={path}
          render={() => (
            <ApprovalAccess adminRoute={admin ? path : undefined}>
              <Page key={scope} />
            </ApprovalAccess>
          )}
        />
      ))}
    </>
  );
}
